/* eslint-disable */
if(process.env.VUE_APP_COLLECT_URL){
    !(function (param) {
      var w = window,
        d = document,
        p = param.sdk_url,
        n = param.sdk_name,
        x = null,
        y = null;
      w[n] =
        w[n] ||
        function (a) {
          return function () {
            (w[n]._q = w[n]._q || []).push([a, arguments]);
          };
        };
      var fn = [
        "init",
        "setMtdsId",
        "pageView",
        "setInfo",
        "setAppCode",
        "setSourceCode",
        "setDefaultActionInfo",
        "setCustomerId",
      ];
      for (var i = 0; i < fn.length; i++) {
        w[n][fn[i]] = w[n].call(null, fn[i]);
      }
      x = d.createElement("script");
      y = d.getElementsByTagName("script")[0];
      x.async = 1;
      x.src = p;
      w[n].param = param;
      y.parentNode.insertBefore(x, y);
    })({
      sdk_url: `${process.env.VUE_APP_COLLECT_URL}?v=${new Date().valueOf()}`, // 根据项目自行修改引用连接
      sdk_name: "opCollect",
    });
  }



// WEBPACK FOOTER //
// ./src/util/statistics.js